import './system.css';

/**
 * Shared loading skeleton. `blocks` is an ordered list of block kinds
 * (e.g. ['chip', 'headline', 'map', 'stats', 'block']), each rendered as a
 * `sys-skeleton-<kind>` placeholder div.
 * @param {{ blocks: string[], label: string }} props
 */
function Skeleton({ blocks, label }) {
  return (
    <div className="sys-skeleton" role="status" aria-label={label}>
      {blocks.map((kind, index) => (
        <div key={`${kind}-${index}`} className={`sys-skeleton-${kind}`} />
      ))}
    </div>
  );
}

export default Skeleton;
